// Vendor Registration Types
export class VendorRegistration {
  constructor(
    id = null,
    name = "",
    phone_number = "",
    company_store_name = "",
    message = "",
    status = "pending",
    created_at = null,
    updated_at = null
  ) {
    this.id = id;
    this.name = name;
    this.phone_number = phone_number;
    this.company_store_name = company_store_name;
    this.message = message;
    this.status = status;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }
}

export class VendorRegistrationsResponse {
  constructor(
    status = false,
    registrations = [],
    pagination = null
  ) {
    this.status = status;
    this.registrations = registrations;
    this.pagination = pagination;
  }
}

export class VendorStatsResponse {
  constructor(status = false, stats = null) {
    this.status = status;
    this.stats = stats;
  }
}

export class VendorDetailResponse {
  constructor(status = false, registration = null) {
    this.status = status;
    this.registration = registration;
  }
}

export class UpdateVendorStatusPayload {
  constructor(status = "") {
    this.status = status;
  }
}

export class VendorQueryParams {
  constructor(
    status = null,
    search = "",
    page = 1,
    limit = 20
  ) {
    this.status = status;
    this.search = search;
    this.page = page;
    this.limit = limit;
  }
}